import { InjectionKey } from 'vue'

export interface LovInputProps {
  maxlength?: string | number
  placeholder?: string
  disabled?: boolean
  // readonly?: boolean
}

export type KeydownHandler = (code: string) => void

export interface LovContext {
  lovValue: any
  backfill: (params: Record<string, any>) => void
  registerKeydownHandler: (handler: KeydownHandler) => void
}

export const lovContextKey: InjectionKey<LovContext> = Symbol('lovContextKey')
